import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import AddSelfManagedAccount from '../SelfManagedAccounts/AddAccount';
import AddFundingRule from '../FundingRules/AddFundingRule';
import FundingRules from '../FundingRules/FundingRules';
import ApproveProctor from './ApproveProctor';
import AssignProctor from './AssignProctor';
import ExamException from '../ExamEdit/ExamException';
import EditExamException from '../ExamEdit/ExamException';
import EnrollmentException from '../ExamEdit/EnrollmentException';
import EditEnrollmentException from '../ExamEdit/EnrollmentException';
import EditProctor from './EditProctor';
import ProctorDetails from './ProctorDetails';
import IncidentReport from './IncidentReport';
import ScheduleOnline from '../StudentDashboard/ScheduleOnline';
import ScheduleHybrid from '../StudentDashboard/ScheduleHybrid';
import ScheduleInstructor from '../StudentDashboard/ScheduleInstructor';
import ScheduleRB from '../StudentDashboard/ScheduleRB';
import ScheduleMessaging from '../StudentDashboard/ScheduleMessaging';
import ScheduleVTC from '../StudentDashboard/ScheduleVTC';
import ScheduleAutomated from '../StudentDashboard/ScheduleAutomated';
import SessionDetail from '../Sessions/SessionDetail';
import SessionStartAutomated from '../SessionStart/SessionStartAutomated';
import SessionStartBV from '../StudentDashboard/SessionStartBV';
import SessionStartExamity from '../StudentDashboard/SessionStartExamity';
import SessionStartHybrid from '../SessionStart/SessionStartHybrid';
import SessionStartProctorU from '../StudentDashboard/SessionStartProctorU';
import SessionStartVTC from '../StudentDashboard/SessionStartVTC';
import StepIn from '../VTC/StepIn';
import VTCReview from '../VTC/Review';
import SupportTicketDetail from '../SupportTickets/SupportTicketDetail';
import AddSupportTicket from '../SupportTickets/AddSupportTicket';
import VoucherList from '../Vouchers/VoucherList';
import AddVoucher from '../Vouchers/AddVoucher';
import EditVoucher from '../Vouchers/EditVoucher';
import LocateProctor from '../LocateProctor/LocateProctor';
import SelectProctor from '../LocateProctor/SelectProctor';
import ReportFilter from '../Reports/ReportFilter';
import MessageThread from '../Messages/MessageThread';
import EditAdmin from '../Admins/EditAdmin';
import EditCourseOffering from '../CourseOfferings/EditCourseOffering';
import UserDetails from '../Modules/UserDetails';
import OAuth from '../Integrations/OAuth';
import Roles from '../Integrations/Roles';
import Sync from '../Integrations/Sync';
import EditBlackoutDate from '../BlackoutDates/EditBlackoutDate';
import Enrollments from '../Roster/Enrollments';
import TallyLoader from '../Common/TallyLoader';
import SessionManage from './SessionManage';
import StudentAssignment from '../Modules/StudentAssignment';

const Drawer = observer(class Drawer extends React.Component {
  render() {
    const { content, isOpen, translation } = this.props;
    const { SessionStore, ScheduleStore } = this.props.store;
    const { pathname } = this.props.routing.location;
    let closeBtnClass = null;
    let closePath = null;
    let callback = null;

    if(this.props.callback) {
      callback = this.props.callback;
    }

    const DrawerComponents = {
      AddSelfManagedAccount: AddSelfManagedAccount,
      AddFundingRule: AddFundingRule,
      FundingRules: FundingRules,
      ApproveProctor: ApproveProctor,
      AssignProctor: AssignProctor,
      ExamException: ExamException,
      EditExamException: EditExamException,
      EditScheduledExamException: EditExamException,
      ViewExamException: EditExamException,
      EnrollmentException: EnrollmentException,
      EditEnrollmentException: EditEnrollmentException,
      EditProctor: EditProctor,
      ProctorDetails: ProctorDetails,
      IncidentReport: IncidentReport,
      ScheduleOnline: ScheduleOnline,
      ScheduleHybrid: ScheduleHybrid,
      ScheduleInstructor: ScheduleInstructor,
      ScheduleRB: ScheduleRB,
      ScheduleMessaging: ScheduleMessaging,
      SessionStartAutomated: SessionStartAutomated,
      SessionStartHybrid: SessionStartHybrid,
      ScheduleVTC: ScheduleVTC,
      ScheduleAutomated: ScheduleAutomated,
      SessionDetail: SessionDetail,
      SessionDetailStudent: SessionDetail,
      SessionStartBV: SessionStartBV,
      SessionStartExamity: SessionStartExamity,
      SessionStartProctorU: SessionStartProctorU,
      SessionStartVTC: SessionStartVTC,
      StepIn: StepIn,
      VTCReview: VTCReview,
      SupportTicketDetail: SupportTicketDetail,
      AddSupportTicket: AddSupportTicket,
      VoucherList: VoucherList,
      AddVoucher: AddVoucher,
      EditVoucher: EditVoucher,
      LocateProctor: LocateProctor,
      SelectProctor: SelectProctor,
      ReportFilter: ReportFilter,
      MessageThread: MessageThread,
      EditAdmin: EditAdmin,
      EditCourseOffering: EditCourseOffering,
      UserDetails: UserDetails,
      OAuth: OAuth,
      Roles: Roles,
      Sync: Sync,
      EditBlackoutDate: EditBlackoutDate,
      Enrollments: Enrollments,
      SessionManage: SessionManage,
      StudentAssignment: StudentAssignment
    }

    if(content === 'AddSelfManagedAccount') {
      closePath = 'self-managed-proctors'
    }

    if(
        content === 'ExamException' ||
        content === 'AssignProctor' ||
        content === 'EditProctor' ||
        content === 'SessionDetail' ||
        content === 'Enrollments'
    ) {
      closePath = `${getURLSegment(this, 1)}/${getURLSegment(this, 2)}`
    }

    if(
      content === 'ExamException' &&
      this.props.approval
    ) {
      closePath = getURLSegment(this, 1);
    }

    if(
        content === 'SupportTicketDetail' ||
        content === 'AddSupportTicket' ||
        content === 'AddFundingRule' ||
        content === 'EditVoucher' ||
        content === 'AddSelfManagedAccount' ||
        content === 'EditAdmin' ||
        content === 'EditCourseOffering' ||
        content === 'UserDetails' ||
        content === 'OAuth' ||
        content === 'Sync' ||
        content === 'Roles' ||
        content === 'EditBlackoutDate'
    ) {
      closePath = getURLSegment(this, 1);
    }

    if(content === 'IncidentReport' || content === 'FundingRules') {
      closePath = pathname.split('?')[0];
    }

    if(
        content === 'StepIn' ||
        content === 'VTCReview'
      ) {
      closeBtnClass = ' drawer__close--inverted'
    }

    if(
        content === 'SessionDetailStudent' ||
        content === 'MessageThread' ||
        content === 'SessionStartBV' ||
        content === 'SessionStartExamity' ||
        content === 'SessionStartProctorU' ||
        content === 'SessionStartVTC'
      ) {
      callback = null;
    }

    if(
      content === 'ScheduleOnline' ||
      content === 'ScheduleHybrid'
      ) {
      callback = () => {
        const examSid = getURLSegment(this, 3);
        const sessionSid = getURLSegment(this, 5);

        if(ScheduleStore.externalReservedAppointmentId) {
          ScheduleStore.cancelReservation(examSid, sessionSid);
        }
      }
    }

    if(isOpen) {
      setTimeout(function(){
        document.querySelector('body').className += ' drawer-open';
      })
    } else {
      document.querySelector('body').classList.remove('drawer-open');
    }

    if(this.props.closePath) {
      closePath = this.props.closePath;
    }

    if((closePath === this.props.routing.location.pathname || `/${closePath}` === this.props.routing.location.pathname) && !this.props.routing.location.search) {
      closePath = null;
    }

    if(content) {
      const DrawerComponent = DrawerComponents[content];

      return(
        <aside id={content} className="drawer" tabIndex="0">
          <DrawerComponent
            {...this.props}
            drawer={true}
            setClosePath={(path) => closePath = path}
          />

          {SessionStore.tallyLoad &&
            <div className="drawer__content">
              <TallyLoader store={this.props.store} routing={this.props.router} />
            </div>
          }

          {!SessionStore.hideDrawerClose &&
            <button className={`drawer__close ${closeBtnClass}`} onClick={(e) => {closeDrawer(e, this.props.parent, closePath, callback)}}>
              <icons.iconTimes />
              <span className="meta">{translation.close}</span>
            </button>
          }
        </aside>
      )
    } else {
      return null;
    }
  }
})

export default translate('Drawer')(Drawer);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/Drawer.js